import axios from 'axios';

export async function fetchRecentTransactions(account) {
  try {
    const response = await axios.get(`https://scan.earth.ooo/api/v2/addresses/${account}/transactions`);
    const transactions = response.data.items || [];

    console.log('Raw API response:', response.data);
    console.log(`Total transactions found: ${transactions.length}`);

    return transactions.slice(0, 10).map(tx => ({
      from: tx.from?.hash || 'Unknown',
      to: tx.to?.hash || 'Unknown',
      value: tx.value || '0',
      hash: tx.hash || 'Unknown'
    }));
  } catch (error) {
    console.error('Error in fetchRecentTransactions:', error);
    throw error;
  }
}